export default __webpack_public_path__ + "static/media/ru.f6fe26be.jpg";